<template>
<v-app id="stats">
    <v-toolbar color="primary" class="empty-stats--toolbar" height=16px flat dark dense>
    </v-toolbar>
    <v-toolbar color="primary" class="stats--toolbar" flat dark dense>
        <v-spacer></v-spacer>
         <v-menu offset-y>            
            <v-btn @click="showModal('filter')" depressed
              slot="activator"
              color="primary"
              dark>
              Filter
            </v-btn>
          </v-menu>        
            <v-menu offset-y>
            <v-btn @click="dashboard" depressed
                slot="activator"
                color="primary"
                dark>
                Dashboard
            </v-btn>
            </v-menu>
            <v-btn icon @click="reload()">
            <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn icon @click="handleFullScreen()">
            <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-btn icon @click="logout()">
            <v-icon>exit_to_app</v-icon>
        </v-btn>
    </v-toolbar>
    <vue-perfect-scrollbar class="chat-history--scrollbar">
        <v-data-table :headers="headers" :items="feedbacks" :rows-per-page-items="[30, 50, 100]"
                :pagination.sync="pagination"  >
            <template v-slot:items="props">
                <td>{{ props.item.UUID }}</td>
                <td>{{ props.item.supplierQuotationNo }}</td>
                <td>{{ props.item.negotiationStatus }}</td>
                <td>{{ props.item.createDate }}</td>
                <td>{{ props.item.feedback }}</td>
            </template>
        </v-data-table>
    </vue-perfect-scrollbar>
    <v-toolbar color="secondary" class="empty-stats--toolbar" height=10px flat dark dense>
    </v-toolbar>
  
<modal name="filter" height=auto>
        <div class="theme--dark primary white--text font-weight-bold d-flex justify-center align-center" style="height:10%">
            Choose filters
        </div>
    <div style="padding:2%">
       <div style="height:72%">
          <div class="d-flex ">
          <div class="picker">            
            <template>
                <date-pick class="picker" v-model="downloadFilter.fromDate" :hasInputElement="false"></date-pick>
            </template>
          </div>
          <div class="picker">
             <template>
            <date-pick class="picker" v-model="downloadFilter.toDate" :hasInputElement="false"></date-pick>
          </template>
          </div>     
        </div>
        <v-btn @click="filterWorklists" color="primary" dark>
            Filter
        </v-btn>
        <v-btn @click="filterWorklistsReset" color="primary" dark>
            Reset Filter
        </v-btn>
       </div>
    </div>    
</modal>

</v-app>
</template>

<script>
import API from '@/api';
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'



export default {

    data: () => ({
        pagination: {    rowsPerPage: 30   },
        search: '',
        headers:[
            {text: "UUID ", value: "UUID", sortable: false},
            {text: "SupplierQuotationNo ", value: "supplierQuotationNo", sortable: false},
            {text: "Status ", value: "negotiationStatus", sortable: false},
            {text: "Date", value: "createDate", sortable: false},
            {text: "Feedback", value: "feedback", sortable: false}
        ],
        feedbacks:[],
        downloadFilter: {
            toDate: new Date().toISOString().split("T")[0],
            fromDate: new Date((new Date).setDate((new Date).getDate() - (new Date).getDay())).toISOString().split("T")[0]
            }
    }),
     components: {
        DatePick,
        VuePerfectScrollbar
    },
    mounted () {
        this.getFeedbacks();
    },
    methods:{
        dashboard(){
            this.$router.push('/chat')
        },
        handleFullScreen () {
            Util.toggleFullScreen()
        },
        reload () {
            window.location.reload()
        },
        logout () {
            window.getApp.$emit('APP_LOGOUT')
        },
        showModal (nameOfModal) {
        this.$modal.show(nameOfModal);
        },
        hideModal (nameOfModal) {
            this.$modal.hide(nameOfModal);
        },
        async getFeedbacks () {
            this.feedbacks = await API.getFeedbacks({});
            console.log(this.tableData);
        },
        async filterWorklists() {
            this.feedbacks = await API.getFeedbacks(this.downloadFilter);
            
            this.hideModal('filter');
        },
        async download(){
            await API.exportLogs();
            },
        filterWorklistsReset(){
            this.downloadFilter = {
               toDate: new Date().toISOString().split("T")[0],
                fromDate: new Date((new Date).setDate((new Date).getDate() - (new Date).getDay())).toISOString().split("T")[0]
            }
        }
    }
    
}
</script>